import React from 'react';

// set the defaults
export const FeatureContext = React.createContext({
  selFeature: 0,
  setSelFeature: () => {},
});
